import { PathType } from 'src/app/shared/enum/path-type.enum';

const METROPOLITAN_PATHS: PathType[] = [
  PathType.MARSEILLE,
  PathType.GRENOBLE,
  PathType.LILLE,
  PathType.PARIS,
  PathType.TOURCOING,
  PathType.CRETEIL,
];

export function isMetropolitanPath(pathType: PathType): boolean {
  return METROPOLITAN_PATHS.includes(pathType);
}
